
import { loadStyle } from '../utils/css'

const STYLE = `
.ae-splitter {
  height: inherit;
  width: 100%;
  display: flex;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}
.ae-splitter--pane {
  height: inherit;
  min-width: 0;
  min-height: 0;
  max-width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.ae-splitter--pane > * {
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
}
.ae-splitter--bar {
  width: 1px;
  min-width: 1px;
  position: relative;
  background: transparent;
}
.ae-splitter--bar::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 1px;
  background-color: #9e9e9e;
  background-color: var(--ae-separator-color, var(--ae-border-color, #9e9e9e));
  z-index: 0;
}
.ae-splitter--bar::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: calc(-1 * var(--grab-padding-left));
  width: calc(1px + var(--grab-padding-left) + var(--grab-padding-right));
  background: transparent;
  cursor: ew-resize;
  z-index: 1;
}
.ae-splitter--knob {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 20px;
  background-color: rgba(158, 158, 158, 0.5);
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.2s, width 0.2s, background-color 0.2s;
  z-index: 2;
}
.ae-splitter--bar:hover .ae-splitter--knob,
.ae-splitter--bar.active .ae-splitter--knob {
  opacity: 1;
  width: 12px;
  background-color: #757575;
}
`

export default {
  /* tslint:disable */
  render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ae-splitter', _vm.containerClass],style:({ cursor: _vm.cursor, userSelect: _vm.userSelect }),on:{"click":_vm.onContainerClick}},[_c('div',{class:['ae-left-pane', 'ae-splitter--pane', _vm.leftPaneClass, { 'ae-expand-region': _vm.limitExpand }],style:({ 'flex-basis': _vm.percent + '%' })},[_vm._t("left-pane")],2),_vm._v(" "),_c('div',{class:['ae-splitter--bar', _vm.barClass, { active: _vm.active }],style:({ '--grab-padding-left': _vm.grabPaddingLeft + 'px', '--grab-padding-right': _vm.grabPaddingRight + 'px' }),on:{"mousedown":_vm.onDown,"touchstart":function($event){$event.preventDefault();return _vm.onDown.apply(null, arguments)}}},[_c('div',{staticClass:"ae-splitter--knob"})]),_vm._v(" "),_c('div',{class:['ae-right-pane', 'ae-splitter--pane', _vm.rightPaneClass, { 'ae-expand-region': _vm.limitExpand }],staticStyle:{"flex":"1"}},[_vm._t("right-pane")],2)])},
  staticRenderFns: [],
  /* tslint:enable */
  
  inject: ['getAeppicContext'],
  props: {
    margin: {
      type: Number,
      default: 10
    },
    limitExpand: {
      type: Boolean,
      default: true
    },
    split: {
      type: Number
    },
    containerClass: String,
    leftPaneClass: String,
    rightPaneClass: String,
    barClass: String,
    grabPadding: {
      type: [Number, Array],
      default: 10,
      validator: (value) => {
        if (typeof value === 'number') return value >= 0
        if (Array.isArray(value)) return value.length === 2 && value.every(v => typeof v === 'number' && v >= 0)
        return false
      }
    }
  },
  data() {
    const Aeppic = this.getAeppicContext('ae-splitter')
    return {
      Aeppic,
      active: false,
      percent: 50,
      hasMoved: false,
      startX: 0,
      startPercent: 0
    }
  },
  computed: {
    userSelect() { return this.active ? 'none' : '' },
    cursor() { return this.active ? 'ew-resize' : '' },
    grabPaddingLeft() {
      return Array.isArray(this.grabPadding) ? this.grabPadding[0] : this.grabPadding
    },
    grabPaddingRight() {
      return Array.isArray(this.grabPadding) ? this.grabPadding[1] : this.grabPadding
    }
  },
  beforeDestroy() {
    this.Aeppic.release()
  },
  mounted() {
    this.Aeppic.setContextRootElement(this.$el)
    loadStyle(STYLE)
  },
  methods: {
    onContainerClick(e) {
      if (e.target.closest('.ae-splitter--bar') && !this.hasMoved) {
        this.percent = 50
        this.$emit('resize')
      }
    },
    onDown(e) {
      this.active = true
      this.hasMoved = false
      this.startX = e.pageX || (e.touches && e.touches[0].pageX)
      this.startPercent = this.percent
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.onStop)
      document.addEventListener('touchmove', this.onDrag, { passive: false })
      document.addEventListener('touchend', this.onStop)
      e.preventDefault()
    },
    onDrag(e) {
      const x = e.pageX || (e.touches && e.touches[0].pageX)
      const delta = x - this.startX
      const width = this.$el.offsetWidth
      const deltaPercent = (delta / width) * 100
      const newPercent = this.startPercent + deltaPercent
      const clamped = Math.max(this.margin, Math.min(100 - this.margin, newPercent))
      if (Math.abs(deltaPercent) > 0.5) this.hasMoved = true
      this.percent = clamped
      this.$emit('resize')
      this.Aeppic.triggerResize()
      e.preventDefault()
    },
    onStop() {
      this.active = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.onStop)
      document.removeEventListener('touchmove', this.onDrag)
      document.removeEventListener('touchend', this.onStop)
    }
  },
  watch: {
    split: {
      handler() {
        if (this.split != null) {
          this.percent = this.split
          this.$emit('resize')
        }
      },
      immediate: true
    }
  }
}
